import type React from 'react'

type Props = {
  disabled?: boolean
}

const WebFrame: React.FC<Props> = ({ disabled }) => (
  <svg
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.7"
      y="0.7"
      width="62.6"
      height="46.6"
      rx="11.3"
      stroke={disabled ? '#ACBDD3' : '#2F7FEF'}
      strokeWidth="1.4"
      strokeOpacity={disabled ? 0.75 : 1}
    />

    <circle
      cx="10.5"
      cy="10.5"
      r="2.5"
      fill={disabled ? '#ACBDD3' : '#2F7FEF'}
      fillOpacity={disabled ? 0.75 : 1}
    />

    <circle
      cx="17.5"
      cy="10.5"
      r="2.5"
      fill={disabled ? '#ACBDD3' : '#2F7FEF'}
      fillOpacity={disabled ? 0.75 : 1}
    />

    <circle
      cx="24.5"
      cy="10.5"
      r="2.5"
      fill={disabled ? '#ACBDD3' : '#2F7FEF'}
      fillOpacity={disabled ? 0.75 : 1}
    />
  </svg>
)

export default WebFrame
